/// <reference path="GC.Spread.Sheets.d.ts" />
import * as React from 'react';
import { Spin } from 'antd';
import { listStore } from '../../stores/list';
import { observer } from 'mobx-react';
import { WeaPopoverHrm } from 'ecCom';
import { loadSpread, releaseSpread } from '../../util/loadSpread';
import "../../style/excelList.less";
export interface IExcelProps {
    store: listStore;
}
export interface IExcelState {
    height: number;
}

@observer
export default class Excel extends React.Component<IExcelProps, IExcelState>{
    test: (str: string) => boolean | undefined;
    excelList:HTMLDivElement|null;
    render() {
        const { store } = this.props;
        const { windowTitle } = store;
        if(windowTitle != ''){
            document.title = windowTitle;
        }
        return (
            <div className="cube-excel-list"  ref={ref=>this.excelList = ref}>
                <WeaPopoverHrm ecId={`${this && this.props && this.props.ecId || ''}_WeaPopoverHrm@lqxrkj`} />
                <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@v4ac7f`} spinning={store.excelStore.loading} size="large">
                    <div className="cube-excel-list-host" ref={ref => store.host = ref}></div>
                </Spin>
            </div>
        )
    }
    componentDidMount() {    
        const { store } = this.props;  
        this.test = loadSpread(this.loadSparedjs);
        store.refresh(); // 为解决切换Excel列表时，未正确绘制的问题
    }

    componentWillUnmount() {
        releaseSpread(this.test);
    }
    
    loadSparedjs = () => {
        const { store } = this.props;
        if (store.host&& (window as any).GC) {
                store.excelStore.init(new GC.Spread.Sheets.Workbook(store.host, {}));
        }
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/Excel.tsx